module.exports = __webpack_public_path__ + "static/media/immutablex.d9ac9a98.png";